import { render, staticRenderFns } from "./TypeFeature.vue?vue&type=template&id=005c88d4&"
import script from "./TypeFeature.vue?vue&type=script&lang=js&"
export * from "./TypeFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports